import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import { getPublicImagePath, ToggleMenu, useAppDispatch, useAppState } from '@nutastic/nutastic-react-app';
import classnames from 'classnames';
import { WebsiteActions } from '../state/actions.mjs';
import Href from './Href';

const componentClass = 'header';

// eslint-disable-next-line react/prop-types
const Header = () => {
    const appDispatch = useAppDispatch();
    const {
        accountState = {} ,
        authState = {}
    } = useAppState();
    const { isActive: accountModalIsActive } = accountState;
    const { isSubscribed, isAuthenticated } = authState;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuButtonClasses = classnames(`${componentClass}__menu-btn`, {
        isMenuOpen: isMenuOpen
    });
    const accountButtonClasses = classnames(`${componentClass}__account-icon`, {
        isMenuOpen: isMenuOpen
    });

    const onAccountButtonClick = () => {
        if (!accountModalIsActive) {
            appDispatch({ type: WebsiteActions.ACCOUNT_MODAL_SHOW });
        }
    };

    const closeTheMenu = () => setIsMenuOpen(false);

    return <React.Fragment>
        <header className={componentClass}>
            <ReactSVG src={getPublicImagePath('logo--wide.svg')} className={`${componentClass}__logo`} />
            <ToggleMenu isOpen={isMenuOpen} animation="slideFromRight" onOuterClick={closeTheMenu} className={`${componentClass}__menu`}>
                <div className="nuMenu">
                    <Href onClick={closeTheMenu} url="/list/music">Music</Href>
                    <Href onClick={closeTheMenu} url="/list/video">Videos</Href>
                    <Href onClick={closeTheMenu} url="/list/artist">Creators</Href>
                </div>
            </ToggleMenu>
        </header>
        <span className={accountButtonClasses} role="button" onClick={onAccountButtonClick}>
            <ReactSVG src={ getPublicImagePath('account-icon.svg') } />
            { isSubscribed && <span><i className="fa fa-check-circle" /></span> }
            { (isAuthenticated && !isSubscribed) && <span className="cuddiieeNotOnTheSub"><i className="fa fa-exclamation-circle" /></span> }
        </span>
        <div className={menuButtonClasses} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            { isMenuOpen ? <ReactSVG src={ getPublicImagePath('close-icon.svg') } /> : <ReactSVG src={ getPublicImagePath('menu-icon.svg') } /> }
        </div>
    </React.Fragment>
};

export default Header;
